<!-- 运维视图: 班组 -->
<template>
    <el-col :span="span" :style="style">
        <el-row v-if="duty == null" class="red-font bold" style="height: 100%; text-align: center; line-height: 80px;">
            无排班
        </el-row>
        <el-row v-if="duty != null">
            <el-col :span="2">
                <div class="margin-top-20">
                    <img style="width: 100%;height: 100%;" src="img/board/team.svg" />
                </div>
            </el-col>
            <el-col :span="16">
                <p>
                    <span class="blockspan">
                        {{duty.departmentName}}&nbsp;&nbsp;
                        {{duty.crewName}}&nbsp;&nbsp;
                        <i class="el-icon-date" style="margin-right:4px;">
                        </i>
                        {{date}}&nbsp;&nbsp;
                    </span>
                    <el-tag :type="tagType" :effect="tagEffect">{{getWorkTimeCfgNameText(duty)}}</el-tag>
                    <el-tag :type="tagType" :effect="tagEffect">{{startTime}}-{{endTime}}</el-tag>
                </p>
                <p>
                    <span>
                        <span v-for="member in duty.members" :key="member.employeeCode">
                            &nbsp;
                            <template v-if="member.isLeader">
                                <el-badge value="班长" class="item" style="margin-right:30px;">
                                    &nbsp;&nbsp;{{member.employeeName}}
                                </el-badge>
                            </template>
                            <template v-if="!member.isLeader">
                                {{member.employeeName}}
                            </template>
                        </span>
                    </span>
                </p>
            </el-col>
            <el-col :span="6" v-if="dutyKey === 'first'">
                <p class="text-right">
                    <span class="red-font bold text-right" v-show="first.logbook == null">
                        当前班-无值班记录
                    </span>
                    <span class="red-font bold text-right" v-show="first.logbook != null && first.logbook.status === 'DRAFT'">
                        当前班-待交班
                    </span>
                    <span class="red-font bold text-right" v-show="first.logbook != null && first.logbook.status === 'HANDLED'">
                        当前班-待接班
                    </span>
                    <span class="bold text-right" v-show="first.logbook != null && first.logbook.status === 'ACCEPTED'">
                        当前班-已接班
                    </span>
                </p>
                <p class="resetbtn">
                    <el-button @click="add(first)" v-if="first.logbook == null"
                               style="color: #409eff; background:#ecf5ff; border-color:#b3d8ff;"
                               type="primary" size="small">
                        生成值班日志
                    </el-button>
                    <el-button @click="toLogbookDetail(first.logbook)" size="small"
                               v-show="first.logbook != null && first.logbook.status === 'DRAFT'">
                        <span>
                            接班详情
                        </span>
                    </el-button>
                    <el-button @click="handover(first)" v-if="first.logbook != null && first.logbook.status === 'DRAFT'"
                            type="primary" size="small">
                        确认交班
                    </el-button>
                    <el-button @click="toLogbookDetail(first.logbook)" size="small"
                               v-show="first.logbook != null && first.logbook.status === 'HANDLED'">
                        <span>
                            交班详情
                        </span>
                    </el-button>
                </p>
            </el-col>
            <el-col :span="6" v-if="dutyKey === 'second'">
                <p class="text-right">
                    <span class="bold text-right">
                        下一班
                    </span>
                    <span class="red-font bold text-right" v-if="second.logbook == null" style="display: none;">
                        下一班-无值班记录
                    </span>
                    <span class="red-font bold text-right" v-if="second.logbook != null && second.logbook.status === 'DRAFT'" style="display: none;">
                        下一班-待交班
                    </span>
                    <span class="red-font bold text-right" v-if="second.logbook != null && second.logbook.status === 'HANDLED'" style="display: none;">
                        下一班-待接班
                    </span>
                    <span class="bold text-right" v-if="second.logbook != null && second.logbook.status === 'ACCEPTED'" style="display: none;">
                        下一班-已接班
                    </span>
                </p>
                <p class="text-right">
                    <span v-if="(first == null || first.logbook != null && first.logbook.status === 'HANDLED') && second.logbook == null">
                        <el-button @click="accept" :disabled="acceptBtnDisabled" type="primary" size="small">确认接班</el-button>
                    </span>
                    <span v-if="(first == null || first.logbook == null || first.logbook.status === 'HANDLED') && second.logbook != null">
                        <el-button @click="accept" :disabled="acceptBtnDisabled" type="primary" size="small" >接班修复</el-button>
                    </span>
                </p>
            </el-col>
        </el-row>
    </el-col>
</template>

<script>
    import {formatDate, parseDate} from "element-ui/src/utils/date-util";
    import {RESOURCE_IP_PORT} from '@/api/server';
    import DutyServer from '@/api/duty';
    import {AuthInfo} from "@/util/user/authInfo";
    import {
        determineDutyKey,
        DUTY_KEY_FIRST,
        DUTY_KEY_SECOND
    } from "@/views/board/operation/operation-board-duty-service";
    import {addParamsToUrl} from "@/util";
    import {getDepartmentById} from "@/service/department-service";

    function dateTimeToTime(dateTime) {
        return dateTime == null ? null : formatDate(parseDate(dateTime, 'yyyy-MM-dd HH:mm:ss'), 'HH:mm');
    }

    function dateTimeToDate(startDateTime, endDateTime) {
        let start = formatDate(parseDate(startDateTime, 'yyyy-MM-dd HH:mm:ss'), 'MM/dd');
        let end = formatDate(parseDate(endDateTime, 'yyyy-MM-dd HH:mm:ss'), 'MM/dd');
        return start === end ? start : `${start} - ${end}`;
    }

    function getType(_this, type1, type2) {
        let type;
        let dutyKey = _this.dutyKey;
        let duties = _this.duties;
        let determinedDutyKey = determineDutyKey(duties);
        if (determinedDutyKey === DUTY_KEY_FIRST) {
            type = dutyKey === DUTY_KEY_FIRST ? type1 : dutyKey === DUTY_KEY_SECOND ? type2 : type2;
        } else if (determinedDutyKey === DUTY_KEY_SECOND) {
            type = dutyKey === DUTY_KEY_FIRST ? type2 : dutyKey === DUTY_KEY_SECOND ? type1 : type2;
        } else {
            type = type2;
        }
        return type;
    }

    function isInMembers(username, members) {
        let inMembers = false;
        for (let i = 0, len = members.length; i < len; i++) {
            if (members[i].employeeCode === username) {
                inMembers = true;
                break;
            }
        }
        return inMembers;
    }

    function getLeaderCode(duty) {
        let leader = null;
        if (duty != null && duty.members != null) {
            for (let i = 0, len = duty.members.length; i < len; i++) {
                if (duty.members[i].isLeader) {
                    leader = duty.members[i];
                    break;
                }
            }
        }
        return leader == null ? null : leader.employeeCode;
    }

    function getStaffsOnDuty(duty) {
        let staffsOnDuty = [];
        if (duty != null && duty.members != null) {
            for (let i = 0, len = duty.members.length; i < len; i++) {
                let member = duty.members[i];
                staffsOnDuty.push({
                    username: member.employeeCode,
                    realName: member.employeeName,
                });
            }
        }
        return staffsOnDuty;
    }

    async function buildLogbookByDuty(duty) {
        let logbook = {};
        logbook.deptId = duty.departmentId;
        logbook.status = 'DRAFT';
        logbook.startDate = duty.startDateTime;
        logbook.endDate = duty.endDateTime;
        logbook.leader = getLeaderCode(duty);
        logbook.duty = duty.workTimeCfgNameText;
        let department = await getDepartmentById(duty.departmentId);
        if (department != null) {
            logbook.orgId = department.orgid;
            logbook.siteId = department.siteid;
        }
        logbook.staffsOnDuty = getStaffsOnDuty(duty);
        return logbook;
    }

    export default {
        name: "operation-board-crew",
        props: {
            span: {
                default: 24,
            },
            duties: {},
            dutyKey: {},
        },
        data() {
            return {
                // teamImageUrl: 'img/board/team.svg',
                acceptBtnDisabled: false,
            };
        },
        computed: {
            duty() {
                let dutyKey = this.dutyKey;
                let duties = this.duties;
                return duties == null || dutyKey == null ? null : duties[dutyKey];
            },
            first() {
                let duties = this.duties;
                return duties == null ? null : duties.first;
            },
            second() {
                let duties = this.duties;
                return duties == null ? null : duties.second;
            },
            style() {
                let dark = {
                    "background-color": "#F2F2F2",
                    "padding": "10px",
                    // "height": "110px", // 110px
                }, bright = {
                    "border-width": "1px",
                    "border-style": "solid",
                    "border-color": "#FFB500",
                    "padding": "10px",
                    // "height": "110px",
                };
                return getType(this, bright, dark);
            },
            tagType() {
                return getType(this, 'warning', 'info');
            },
            tagEffect() {
                return getType(this, 'light', 'plain');
            },
            date() {
                let duty = this.duty;
                return duty == null ? null : dateTimeToDate(duty.startDateTime, duty.endDateTime);
            },
            startTime() {
                let duty = this.duty;
                return duty == null ? null : dateTimeToTime(duty.startDateTime);
            },
            endTime() {
                let duty = this.duty;
                return duty == null ? null : dateTimeToTime(duty.endDateTime);
            },
        },
        methods: {
            async accept() {
                let promise;
                let duties = JSON.parse(JSON.stringify(this.duties));
                let canAccept = false;
                if (duties.first != null && isInMembers(AuthInfo.userName, duties.first.members)) {
                    this.$message.error(`值班人员不能直接接班！`);
                    canAccept = false;
                } else if (!isInMembers(AuthInfo.userName, duties.second.members)) {
                    try {
                        await this.$confirm(`您不是该班次的接班人员，确认接班吗？`);
                        canAccept = true;
                    } catch (e) {
                        canAccept = false;
                    }
                } else {
                    canAccept = true;
                }
                if (canAccept && duties.first != null && duties.first.logbook != null && !duties.first.logbook.handoverToolsConfirm) {
                    this.$message.error(`交接工具未确认，请先确认交接工具！`);
                    canAccept = false;
                }
                if (canAccept) {
                    promise = this.doAccept(duties);
                } else {
                    promise = Promise.resolve(false);
                }
                return promise;
            },
            async doAccept(duties) {
                let departmentId, startDateTime, endDateTime;
                if (duties.first != null) {
                    departmentId = duties.first.departmentId;
                    startDateTime = duties.first.startDateTime;
                    endDateTime = duties.first.endDateTime;
                } else if (duties.second != null) {
                    departmentId = duties.second.departmentId;
                    startDateTime = null;
                    endDateTime = null;
                }
                let body = {
                    departmentId: departmentId,
                    accepter: AuthInfo.userName,
                    accepterName: AuthInfo.userRealName,
                    acceptDate: formatDate(new Date(), 'yyyy-MM-dd HH:mm'),
                    startDateTime: startDateTime,
                    endDateTime: endDateTime,
                };
                this.acceptBtnDisabled = true;
                let success = false;
                let response;
                try {
                    response = await DutyServer.logbook.acceptDuties(body);
                } finally {
                    this.acceptBtnDisabled = false;
                }
                if (response.status === 200 && response.data.code === 200) {
                    success = true;
                } else {
                    this.$message.error(response.data.message);
                }
                this.$emit('after-accept', success);
                return Promise.resolve(success);
            },
            async handover(duty) {
                let promise;
                let members = duty.members;
                let canHandover = false;
                let inMembers = isInMembers(AuthInfo.userName, members);
                if (!inMembers) {
                    try {
                        await this.$confirm(`您不是该班次的值班人员，确认交班吗？`);
                        canHandover = true;
                    } catch (e) {
                        canHandover = false;
                    }
                } else {
                    canHandover = true;
                }
                if (canHandover) {
                    let response = await DutyServer.handoverMatter.getHandoverMatters(duty.logbook.deptId, duty.logbook.logbookId);
                    if (response.status === 200) {
                        if (String(response.data.code) === '200') {
                            let handoverMatters = response.data.result;
                            if (handoverMatters.length <= 0) {
                                try {
                                    await this.$confirm(`您没有填写交接班事项，确认交班吗？`);
                                    canHandover = true;
                                } catch (e) {
                                    canHandover = false;
                                }
                            } else {
                                canHandover = true;
                            }
                        } else {
                            canHandover = false;
                            this.$message.error(response.data.message);
                        }
                    } else {
                        canHandover = false;
                        this.$message.error(response.data != null ? response.data.message : response.statusText);
                    }
                }
                if (canHandover) {
                    promise = this.doHandover(duty);
                } else {
                    promise = Promise.resolve(false);
                }
                return promise;
            },
            async doHandover(duty) {
                let logbook = duty.logbook;
                logbook.handover = AuthInfo.userName;
                logbook.handoverName = AuthInfo.userRealName;
                logbook.handoverDate = formatDate(new Date(), 'yyyy-MM-dd HH:mm');
                let success = false;
                let response = await DutyServer.logbook.handover(logbook.logbookId, true, logbook);
                if (response.status === 200 && response.data.code === 200) {
                    success = true;
                } else {
                    this.$message.error(response.data.message);
                }
                this.$emit('after-handover', success);
                return Promise.resolve(success);
            },
            async add(duty) {
                if (duty != null) {
                    let logbook = await buildLogbookByDuty(duty);
                    let response = await DutyServer.logbook.add(logbook);
                    let success = false;
                    if (response.status === 200 && response.data.code === 200) {
                        success = true;
                    } else {
                        this.$message.error(response.data.message);
                    }
                    this.$emit('after-add', success);
                    return Promise.resolve(success);
                }
            },
            toLogbookDetail(logbook) {
                window.open(addParamsToUrl(`${process.env.VUE_APP_WEB_API}/athub/logbook/logbook.html`, {
                    m: 6501,
                    module: 'details',
                    id: logbook.logbookId,
                }));
            },
            getWorkTimeCfgNameText(duty) {
                // debugger;
                let workTimeCfgNameText = duty.workTimeCfgNameText;
                if (workTimeCfgNameText == null || workTimeCfgNameText === '') {
                    if (duty.startDateTime !== null) {
                        let time = formatDate(parseDate(duty.startDateTime, 'yyyy-MM-dd HH:mm:ss'), 'HH:mm:ss');
                        if (time <= '12:00:00') {
                            workTimeCfgNameText = '早班';
                        } else {
                            workTimeCfgNameText = '晚班';
                        }
                    } else if (duty.endDateTime !== null) {
                        let time = formatDate(parseDate(duty.endDateTime, 'yyyy-MM-dd HH:mm:ss'), 'HH:mm:ss');
                        if (time > '12:00:00') {
                            workTimeCfgNameText = '早班';
                        } else {
                            workTimeCfgNameText = '晚班';
                        }
                    } else {
                        workTimeCfgNameText = '班次';
                    }
                }
                return workTimeCfgNameText;
            },
        }
    }
</script>

<style scoped>

</style>
